import { Box, Grid, Typography, useTheme } from "@mui/material";
import Login from "@/components/Auth/Login";
import Logo from "@/components/UI-Kit/Logo";
import useResponsive from "@/hooks/useResponsive";

const LoginPage = () => {
  const theme = useTheme();
  const isMobile = useResponsive("down", "sm");
  const isDesktop = useResponsive("up", "md");

  return (
    <>
      <Grid container component="main">
        <Grid
          item
          component="section"
          xs={12}
          md={6}
          sx={{ pt: { xs: 0, md: 2, lg: 4 }, pb: { xs: 5, md: 10, lg: 20 } }}
        >
          <Box
            maxWidth={760}
            boxSizing="border-box"
            ml="auto"
            mr={{ xs: "auto", md: 0 }}
            pl={{ xs: 2, sm: 3 }}
            pr={{ xs: 2, sm: 3, md: 4 }}
          >
            <Box maxWidth={518} mx="auto" boxSizing="border-box">
              <Box
                py={{ xs: 2.5, md: 4, lg: 5 }}
                textAlign={{ xs: "center", md: "start" }}
                mb={{ md: 6, lg: 8 }}
              >
                <Logo
                  type="dark"
                  width={isMobile ? 132 : 204}
                  height={isMobile ? 25 : 38}
                />
              </Box>
              <Typography
                variant="h1"
                color="text.primary"
                mb={{ xs: 2, md: 1 }}
              >
                Log in
              </Typography>
              <Typography
                variant="subtitle1"
                component="p"
                fontSize="1rem !important"
                fontWeight={{ xs: 500, md: 600 }}
                color="text.secondary"
                mb={4}
              >
                To ensure a personalized and streamlined experience, we invite
                you to log in to your account.
              </Typography>
              <Login goToLoginCheckout={() => {}} setCheckoutData={() => {}} />
            </Box>
          </Box>
        </Grid>

        {isDesktop && (
          <Grid
            item
            component="section"
            xs={12}
            md={6}
            bgcolor={{ xs: theme.palette.grey[300], md: "background.default" }}
          ></Grid>
        )}
      </Grid>
    </>
  );
};

export default LoginPage;
